import { jsxs as y, jsx as e } from "react/jsx-runtime";
import g from "react-date-picker";
import { Button as w } from "../Button/index.js";
import { CalendarIcon as k } from "../Icons/objects/CalendarIcon.js";
import { ErrorMessage as v } from "../ErrorMessage/index.js";
import { SmallDoubleChevronLeft as l } from "./Assets/SmallDoubleChevronLeft.js";
import { SmallChevronLeft as m } from "./Assets/SmallChevronLeft.js";
import o from "dayjs";
import { p as x, u as L } from "../uk-DtS-21WL.js";
o.locale(x);
o.locale(L);
const P = ({
  label: t,
  error: a,
  locale: s = "pl",
  format: n = "dd-MM-yyyy",
  dayPlaceholder: c = "DD",
  monthPlaceholder: i = "MM",
  yearPlaceholder: p = "RRRR",
  clearIcon: d = null,
  openCalendarOnFocus: f = !1,
  showLeadingZeros: j = !1,
  ...r
}) => {
  const u = typeof a == "string";
  return /* @__PURE__ */ y("div", { className: "jm-grid jm-gap-1", children: [
    t && /* @__PURE__ */ e(
      "label",
      {
        htmlFor: r.name,
        className: "jm-font-label jm-block jm-w-full jm-text-jutro-new-warm-gray-800",
        children: t
      }
    ),
    /* @__PURE__ */ e(
      g,
      {
        ...r,
        className: `jm-date-picker-wrapper ${a && "jm-date-picker-wrapper--error"}`,
        format: n,
        locale: s,
        calendarIcon: /* @__PURE__ */ e(
          w,
          {
            label: "Select date",
            withTooltip: !1,
            size: "condensed",
            variant: "ghost",
            icon: /* @__PURE__ */ e(k, { size: "sm" }),
            disabled: r.disabled,
            type: "button"
          }
        ),
        clearIcon: d,
        openCalendarOnFocus: f,
        dayPlaceholder: c,
        monthPlaceholder: i,
        yearPlaceholder: p,
        showLeadingZeros: j,
        calendarProps: {
          prevLabel: /* @__PURE__ */ e(m, {}),
          prev2Label: /* @__PURE__ */ e(l, {}),
          nextLabel: /* @__PURE__ */ e(m, { className: "jm-custom-rotate-180" }),
          next2Label: /* @__PURE__ */ e(l, { className: "jm-custom-rotate-180" }),
          formatShortWeekday: (b, h) => o(h).locale(b).format("dd")
        }
      }
    ),
    u && /* @__PURE__ */ e(v, { error: a })
  ] });
};
export {
  P as DateInput
};
//# sourceMappingURL=index.js.map
